export const ALL = Symbol('ALL');
export const OPEN = Symbol('OPEN');
export const CLOSED = Symbol('CLOSED');

export const NEW_CUSTOMER_AND_FULL = Symbol('NEW_CUSTOMER_AND_FULL');
export const FULL = Symbol('FULL');
export const NEW_CUSTOMER = Symbol('NEW_CUSTOMER');

export const dsaStatusFilters = [
  {
    id: ALL,
    label: 'Showing: All',
    fn: a => a
  },
  {
    id: OPEN,
    label: 'Showing: Closed',
    fn: a => a.state === 'closed'
  },
  {
    id: CLOSED,
    label: 'Showing: Open',
    fn: a => a.state !== 'closed'
  }
];


export const dsaTypeFilters = [
  {
    id: NEW_CUSTOMER_AND_FULL,
    label: 'Showing: New Customer and Full',
    fn: a => a
  },
  {
    id: FULL,
    label: 'Showing: Full',
    fn: a => a.dsaType === 'full'
  },
  {
    id: NEW_CUSTOMER,
    label: 'Showing: New Customer',
    fn: a => a.dsaType === 'new-customer'
  }
];





// WEBPACK FOOTER //
// ./src/constants/dsaFilters.js